import React from "react";
// react redux connect
import { connect } from 'react-redux';

// material ui imports - core
import {
  Grid,
  CircularProgress,
  TextField,
  IconButton
} from "@material-ui/core";
// icons
import SendIcon from '@material-ui/icons/Send';
// pickers
import {
  DateTimePicker,
  MuiPickersUtilsProvider,
} from '@material-ui/pickers';
// picker utils
import MomentUtils from '@date-io/moment';

// lodash isempty
import { isEmpty } from 'lodash';
// react modal
import ReactModal from 'react-modal';
// styled components
import styled from 'styled-components';
// js moment
import moment from 'moment';
// Messaging Server Key import
import { FIREBASE_MESSAGING_SERVER_KEY } from '../../config/config.json';
// redirect user if privileges not found
import { Redirect } from "react-router-dom";

// homemade component imports
import {
  RegularCard,
  Button,
  ItemGrid,
} from "../../components";

// reducer imports
import {
  saveNotification,
  loadNotifications,
  editNotification,
  deleteNotification
} from './reducer/actions';

// react big calendar imports
import "react-big-calendar/lib/css/react-big-calendar.css";
import { Calendar, momentLocalizer } from 'react-big-calendar';

// TODO: import hash to allow sending to individual shards

// time to local time
const localizer = momentLocalizer(moment);

// modal styles
const ModalHeader = styled.div`
  display: flex;
  justify-content: space-between;
  font-weight: bold;
  padding: 20px;
  border-bottom: 1px solid rgba(153, 153, 153, 0.7);
`
const ModalContent = styled.div`
  position: relative;
  padding: 20px 20px;
  overflow: hidden;
  padding-bottom: 20px;
  line-height: 50px;
`
const ModalFooter = styled.div`
  display: flex;
  justify-content: center;
  padding: 20px;
  border-top: 1px solid rgba(153, 153, 153, 0.7);
`

// modal style sheets
const customModalStyles = {
  overlay: {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'rgba(15, 102, 128, 0.5)',
    zIndex: 1000,
  },
  content: {
    top: 'calc(50% + 30px)',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    marginRight: '-50%',
    transform: 'translate(-50%, -50%)',
    padding: '0px !important',
    width: '572px'
  }
};

// class declaration
class Notifications extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedNotification: null, // notification selected by user
      newNotification: '', // text of new notification
      scheduledTime: new Date(), // date sent/to be sent
      showNotificationModal: false, // show the modal
      isEditing: false, // editing a notification
    };
  }

  // component will mount
  componentWillMount() {
    this.props.loadNotifications(this._onSuccess.bind(this), this._onError.bind(this));
  }

  // the actual process of sending out a notification
	sendNotification(date = null) {
    // where the notification goes to
    const PUSH_ENDPOINT = 'https://fcm.googleapis.com/fcm/send';
    // the newly created notification
    const content = this.state.newNotification;

    if (date === null) {
      fetch(PUSH_ENDPOINT, {
        method: "POST",
        headers: {
          'Authorization': `key=${FIREBASE_MESSAGING_SERVER_KEY}`,
          "Content-Type": "application/json"
        },
        body: JSON.stringify({
          to: "/topics/all",
          content_available: true,
          notification: {
            body: content,
            sound: "default"
          },
          data: {
            body: content
          },
          priority: 'HIGH',
          sound: "default"
        })
      })
      .then(r => {
        console.log('Reply from FCM endpoint:', r);
        alert('Notification sent');
      });
    } else {
      alert('Scheduled notification successfully!');
    }

    // otherwise, it is scheduled
    this.props.saveNotification({
      content,
      scheduled: date,
      sent: date == null,
      date: date || moment().toISOString(),
    });
    // revert the contents of the input box
    this.setState({ scheduledTime: null, newNotification: ''});
  }

  // delete an existing Notification
  handleDeleteNotification() {
    this._onDeleteNotification(this.state.editingNotification);
    this.setState({showNotificationModal: false})
  }

  // show a block that allows users to schedule notifications
  renderScheduler() {
    return (
      <div>
        <DateTimePicker
          label={'Notification Date and Time'}
          value={moment(this.state.scheduledTime).format('YYYY-MM-DDTHH:mm')}
          onChange={(e) => {this.setState({ scheduledTime: e })}}
          defaultValue={moment().add(1, 'd').format('YYYY-MM-DDTHH:00')}
        />
        <IconButton
          onClick={() => {
            this.sendNotification(moment(this.state.scheduledTime).toISOString());
            this.setState({shouldSchedule: false, scheduledTime: null })
          }}
          tooltip="Send"
        >
          <SendIcon />
        </IconButton>
      </div>
    );
  }

  // top block above calendar
  renderSendNotification() {
    // set state and props
    const { newNotification = '', shouldSchedule } = this.state;
    return (
      <Grid container style={{paddingBottom: 35}}>
        <ItemGrid xs={12} sm={12} md={6}>
          {/* das big text input block */}
          <div style={{ backgroundColor: '#eee', width: '100%', padding: '1rem'}} >
            <TextField
              style={{ width: '100%'}}
              multiline
              rows={6}
              rowsMax={6}
              placeholder='New Notification'
              hintText='New Notification'
              hintStyle={{ fontSize: 14 }}
              label='Notification Text'
              floatingLabelStyle={{ fontSize: 22 }}
              floatingLabelFixed={true}
              value={newNotification}
              onChange={(evt) => {this.setState({ newNotification: evt.target.value })}}
            />
          </div>
        </ItemGrid>
        <ItemGrid xs={12} sm={12} md={3}>
          <div style={{paddingLeft: '2rem'}}>
            <Button
              disabled={newNotification.length < 10 || shouldSchedule}
              fullWidth
              onClick={() => {this.state.isEditing ?
                this._onEditNotification(this.state.editingNotification) : this.sendNotification()}
              }
            >
              {this.state.isEditing ? 'Edit Notification' : 'Send Notification'}
            </Button>
            <br/>
            <Button
              fullWidth
              disabled={newNotification.length < 10 || shouldSchedule}
              onClick={() => this.setState({
                shouldSchedule: true,
                scheduledTime: moment().add(1, 'd').format('YYYY-MM-DDTHH:00')
              })}
            >
              Schedule Notification
            </Button>
            { shouldSchedule ? this.renderScheduler() : null }
          </div>
        </ItemGrid>
      </Grid>
    );
  }

  renderNotificationModal() {
    const { newNotification } = this.state;

    return(
      <ReactModal
        isOpen={this.state.showNotificationModal}
        // onRequestClose={() => this.onCloseModal()}
        closeTimeoutMS={450}
        contentLabel={'Notification'}
        ariaHideApp={false}
        style={customModalStyles}
      >
        <ModalHeader>
          {this.state.isEditing? 'Edit Notification' : 'Create New Notification'}
        </ModalHeader>
        <ModalContent>
          <Grid container>
            <ItemGrid xs={12} sm={12}>
              <div style={{ backgroundColor: '#eee', width: '100%', paddingBottom: '5px'}} >
                <TextField
                  style={{ width: '100%'}}
                  multiline
                  rows={6}
                  rowsMax={6}
                  placeholder='New Notification'
                  hintText='New Notification'
                  hintStyle={{ fontSize: 14 }}
                  label='Notification Text'
                  floatingLabelStyle={{ fontSize: 22 }}
                  floatingLabelFixed={true}
                  value={newNotification}
                  onChange={(evt) => {this.setState({ newNotification: evt.target.value })}}
                />
              </div>
            </ItemGrid>
            <ItemGrid xs={12} sm={12}>
              <div style={{justifyContent: 'center', alignContent: 'center',}}>
                <DateTimePicker
                  label={'Notification Date and Time'}
                  value={moment(this.state.scheduledTime).format('YYYY-MM-DDTHH:mm')}
                  onChange={(e) => {this.setState({ scheduledTime: e })}}
                />
              </div>
            </ItemGrid>
          </Grid>
        </ModalContent>
        <ModalFooter style={{justifyContent: 'space-evenly'}}>
          <Button
            disabled={isEmpty(this.state.newNotification)}
            onClick={(e) => { this.state.isEditing ?
              this._onEditNotification()
              :
              this._onCreateNewNotification()}
            }
          >
            {this.state.isEditing? 'Edit' : 'Schedule'}
          </Button>
          <Button
            onClick={(e) => {this.setState({ showNotificationModal: false })}}
          >
            Cancel
          </Button>
          { this.state.isEditing ?
            <Button
              style={{backgroundColor: '#ff6666'}}
              onClick={() => {this.handleDeleteNotification()}}
            >
              Delete
            </Button>
            : null
          }
        </ModalFooter>
      </ReactModal>
    );
  }

  handleCreateNotifications() {
    this.sendNotification(moment(this.state.scheduledTime).toISOString());
    this.setState({ scheduledTime: new Date(), showNotificationModal: false});
  }

  initCreateNewNotification(item) {
    let defaultDate = moment(item.start).format('YYYY-MM-DDThh:mm');

    this.setState({
      date: defaultDate,
      scheduledTime: defaultDate,
      newNotification: '',
      showNotificationModal: true,
    });
  }

  // begin editing a notification from the top box
  initEditNotification (id) {
    const { notifications } = this.props;
    const curNotification = notifications.filter(notifs => (notifs.id === id))[0];

    this.setState({
      newNotification: curNotification.content,
      scheduledTime: curNotification.date,
      date: curNotification.date,
      isEditing: true,
      editingNotification: id,
      notificationText: curNotification.content,
      selectedNotification: curNotification,
    });
  }

  // intentionally left blank
	_onSuccess() {

	}
  // log errors
	_onError(error) {
    console.log(error);
  }

  _onCreateNewNotification() {
    this.setState({ isLoading: true });
    this.handleCreateNotifications();
    this.props.loadNotifications(this._onSuccess.bind(this), this._onError.bind(this));
  }

  // on confirm, edit the notification, and return to normal operations
  _onEditNotification (id) {
    this.props.editNotification(this.state.editingNotification, {
        content: this.state.newNotification,
        id: this.state.editingNotification,
        date: this.state.scheduledTime,
        scheduledTime: this.state.scheduledTime,
    }, this._onSuccess.bind(this), this._onError.bind(this));
    this.setState({newNotification: '', isEditing: false, showNotificationModal: false});
  }

  // remove a notification wholesale
  _onDeleteNotification (id) {
    this.props.deleteNotification(id, this._onSuccess.bind(this), this._onError.bind(this));
  }

  handleNotificationPress(item) {
    this.setState({showNotificationModal: true, isEditing: true});
    this.initEditNotification(item.id)
  }

  handleSlotPress(item) {
    this.setState({showNotificationModal: true, isEditing: false,});
    this.initCreateNewNotification(item);
  }

  eventStyleGetter(e) {
    let background = '';
    if(moment(e.date).isBefore()) {
      background = '#DCDCDC';
    } else { background = '#00acc1' }
    var style = {
        background: background,
        borderRadius: '2px',
        opacity: 0.8,
        color: 'black',
        border: '0px',
        display: 'block'
    };
    return {
        style: style
    };
  }

  // render the page
  render() {
    // set state and props
    const notifications = this.props.notifications;

    if (!this.props.user.hasOwnProperty('admin')) {
      return (
        <Redirect from={'news'} to={'dashboard'} key={'invalid'} />
      );
    }
    // check for rights for this page in particular
    if (!this.props.user.admin.master &&
      !this.props.user.admin.hasOwnProperty('notifications'))
    {
      return (
        <Redirect from={'notifications'} to={'dashboard'} key={'noTicket'} />
      );
    }

    return (
      <MuiPickersUtilsProvider
        utils={MomentUtils}
      >
        <RegularCard
          cardTitle="Notifications"
          content={
            <div>
              <Grid container>
                {/* Pre-existing Notifications are rendered here */}
                <ItemGrid xs={12} sm={12} md={12}>
                  <h5>Notifications Scheduled: {this.props.scheduledNotifsCount}</h5>
                  <br />
                  {this.renderSendNotification()}
                  {this.props.isLoading &&
                    <div style={{padding: 10, textAlign: 'center'}}>
                      <CircularProgress />
                    </div>
                  }
                  {!this.props.isLoading?
                  <div style={{height: '50vh', width: '100%', paddingBottom: 50}}>
                    <Calendar
                      localizer={localizer}
                      defaultDate={new Date()}
                      defaultView="month"
                      events={notifications}
                      selectable
                      onSelectEvent={(e) => this.handleNotificationPress(e)}
                      onSelectSlot={(e) => this.handleSlotPress(e)}
                      startAccessor={(e) => new Date(e.date)}
                      endAccessor={(e) => new Date(e.date)}
                      eventPropGetter={this.eventStyleGetter}
                      titleAccessor={'content'}
                    />
                    </div>
                    : null}
                  <br />
                </ItemGrid>

              </Grid>
              {this.renderNotificationModal()}
            </div>
          }
        />
      </MuiPickersUtilsProvider>
    );
  }
}

const mapDispatchToProps = {
  loadNotifications,
  saveNotification,
  editNotification,
  deleteNotification,
};

const mapStateToProps = (state) => {
  let notifications = state.notificationReducer.notifications;
  let scheduledNotifsCount = notifications.filter(notif => !notif.sent);
  scheduledNotifsCount = scheduledNotifsCount.length;

  return {
    user: state.authReducer.user,
    scheduledNotifsCount: scheduledNotifsCount,
  	notifications: state.notificationReducer.notifications,
  	isLoading: state.notificationReducer.isLoading
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Notifications)
